/**
 * Created by TF on 2018/6/20
 */
import axios from 'axios';

let qs = require('qs');

let base = 'http://47.104.248.56:8081';

var instance = axios.create({
  headers: {
    // 'content-type': 'application/json',
    // 'tokenId': ''
    'Authorization': ''
  }
});

instance.interceptors.request.use(
  config => {
    config.headers.Authorization = sessionStorage.getItem('Authorization');
    return config
  }, err => {
    return Promise.reject(err)
  });


export const reqGetLogin = params => { return instance.post(`${base}/webUser/login`, qs.stringify(params)).then(res => res.data) }
export const reqGetRegister = params => { return instance.post(`${base}/webUser/register`, params) }
export const reqGetUserListPage = params => { return instance.get(`${base}/admin/query/adminUser`, { params: params }) };
export const reqAddUser = params => { return instance.post(`${base}/admin/add/adminUser`, qs.stringify(params) ) };
export const reqEditUser = params => { return instance.post(`${base}/admin/update/adminUser`, qs.stringify(params) ) };
export const reqEditUserPWD = params => { return instance.post(`${base}/admin/update/pwd`, qs.stringify(params) ) };
export const reqEditWebUserPWD = params => { return instance.post(`${base}/admin/update/webUserPWD`, qs.stringify(params) ) };
export const reqDeleteUser = params => { return instance.get(`${base}/admin/del/adminUser`, { params: params } ) };
export const reqSaveUserProfile = params => { return instance.post(`${base}/user/profile`, params).then(res => res.data) };


export const reqGetIdentifyingCode = params => { return instance.post(`${base}/webUser/getIdentifyingCode`, params) }
export const reqGetVcodeImg = params => { return instance.get(`${base}/webUser/getVcodeImg`, {params: params}) }
// 获取短信验证码前先校验图片验证码是否输入正确.
export const reqCheckImgCode = params => { return instance.get(`${base}/webUser/CheckImgCode`, {params: params}) }
// 查询一个用户信息(信息中去掉用户密码)
export const reqGetWebUserById = params => { return instance.get(`${base}/webUser/userById`, { params: params }) };


export const reqGetRoleListPage = params => { return instance.get(`${base}/role/query/adminRole`, { params: params }) };
export const reqAddRole = params => { return instance.post(`${base}/role/add/adminRole`, qs.stringify(params))};
export const reqEditRole = params => { return instance.post(`${base}/role/update/adminRole`, qs.stringify(params)) };
export const reqDeleteRole = params => { return instance.get(`${base}/role/del/adminRole`, { params: params } ) };
export const reqGetRoleListAll = params => { return instance.get(`${base}/role/query/adminRoleAll`, { params: params }) };

export const reqGetMenuListPage = params => { return instance.get(`${base}/adminPermission/query/adminPermissionList`, { params: params }) };
export const reqGetParentMenuList = params => { return instance.get(`${base}/adminPermission/query/parentPermission`, { params: params }) };
export const getAllParentPermission = params => { return instance.get(`${base}/adminPermission/query/queryAllParentPermission`, { params: params }) };
export const reqGetPermissionButton = params => { return instance.get(`${base}/adminPermission/query/adminPermissionButton`, { params: params }) };
export const reqParentAndChildPermission = params => { return instance.get(`${base}/adminPermission/query/queryParentAndChildPermission`, { params: params }) };
export const reqAddMenu = params => { return instance.post(`${base}/adminPermission/add/adminPermission`, qs.stringify(params)) };
export const reqEditMenu = params => { return instance.post(`${base}/adminPermission/edit/adminPermission`, qs.stringify(params)) };
export const reqDeleteMenu = params => { return instance.get(`${base}/adminPermission/del/adminPermission`, { params: params }) };
export const reqGetAllMenuList = params => { return instance.get(`${base}/adminPermission/queryAdminPermission`, { params: params }) };

export const reqGetChildMenuList = params => { return instance.get(`${base}/adminPermission/query/subPermission`, { params: params }) };
export const reqEditChildMenu = params => { return instance.get(`${base}/childMenu/edit`, { params: params }) };
export const reqDeleteChildMenu = params => { return instance.get(`${base}/childMenu/delete`, { params: params }) };

// 数据字典
export const reqGetDictionaryList = params => { return instance.get(`${base}/dictionary/list`, { params: params }) };
export const reqGetDictionaryListByCode = params => { return instance.get(`${base}/dictionary/getListByCode`, { params: params } ) };
export const reqGetDictionaryParentList = params => { return instance.get(`${base}/dictionary/getParentList`, { params: params } ) };
export const reqGetKnowInvestmentStageList = params => { return instance.get(`${base}/dictionary/getKnowInvestmentStage`, { params: params } ) };
export const reqGetKnowWayList = params => { return instance.get(`${base}/dictionary/getKnowWay`, { params: params } ) };
export const reqAddDictionary = params => { return instance.post(`${base}/dictionary/add`, params) };
export const reqEditDictionary = params => { return instance.post(`${base}/dictionary/edit`, params) };
export const reqDeleteDictionary = params => { return instance.delete(`${base}/dictionary/delete/`+params.id, params ) };
export const reqBatchDeleteDictionary = params => { return instance.post(`${base}/dictionary/batchdelete`, params) };
export const reqGetOneByCode = params => { return instance.get(`${base}/dictionary/one`, { params: params }) };

export const reqGetBacklogList = params => { return instance.get(`${base}/backlog/list`, { params: params }) };
export const reqGetBacklogCount = params => { return instance.get(`${base}/backlog/count`, { params: params }) };
export const reqEditBacklog = params => { return instance.get(`${base}/backlog/edit`, { params: params }) };

export const reqGetOperationlogList = params => { return instance.get(`${base}/operationlog/list`, { params: params }) };
export const reqDeleteOperationlog = params => { return instance.delete(`${base}/operationlog/delete/`+params.id, params ) };
export const reqBatchDeleteOperationlog = params => { return instance.post(`${base}/operationlog/batchdelete`, params) };

export const reqGetArchivesListByOtherId = params => { return instance.get(`${base}/archives/getListByOtherId`, { params: params }) };
export const reqAddArchives = params => { return instance.post(`${base}/archives/add`, params) };
export const reqDeleteArchives = params => { return instance.delete(`${base}/archives/delete/`+params.id, params ) };

export const reqGetDjbaChartData = params => { return instance.get(`${base}/dashboard/djbaChartData`, { params: params } ) };
export const reqGetScjdChartData = params => { return instance.get(`${base}/dashboard/scjdChartData`, { params: params } ) };
export const reqGetXzajChartData = params => { return instance.get(`${base}/dashboard/xzajChartData`, { params: params } ) };
export const reqGetTsjbChartData = params => { return instance.get(`${base}/dashboard/tsjbChartData`, { params: params } ) };
export const reqGetNbgwChartData = params => { return instance.get(`${base}/dashboard/nbgwChartData`, { params: params } ) };
export const reqGetHzChartData = params => { return instance.get(`${base}/dashboard/hzChartData`, { params: params } ) };

export const reqAddAttachment = params => { return instance.post(`${base}/attachment/add`, params) };
export const reqDeleteAttachment = params => { return instance.delete(`${base}/attachment/delete/`+ params.id, params ) };
export const reqBatchDeleteAttachment = params => { return instance.post(`${base}/attachment/batchdelete`, params) };

export const reqGetAllCountries = params => { return instance.get(`${base}/region/allCountries`, { params: params }) };
export const reqGetListByParentCode = params => { return instance.get(`${base}/region/getListByParentCode`, { params: params } ) };
export const reqGetConcernedListByParentCode = params => { return instance.get(`${base}/region/getConcernedListByParentCode`, { params: params } ) };
export const reqGetFamiliarListByParentCode = params => { return instance.get(`${base}/region/getFamiliarListByParentCode`, { params: params } ) };
export const reqGetCityListByParentCode = params => { return instance.get(`${base}/region/getCityListByParentCode`, { params: params } ) };
export const reqGetDialingCodeList = params => { return instance.get(`${base}/region/dialingCode`, { params: params } ) };
export const reqGetHotRegions = params => { return instance.get(`${base}/region/hotRegions`, { params: params }) };
export const reqGetHotCountries = params => { return instance.get(`${base}/region/hotCountries`, { params: params }) };
export const reqGetDictionaryByIdList = params => { return instance.get(`${base}/dictionary/getByIdList`, { params: params } ) };
export const reqDictionaryConvert = params => { return instance.get(`${base}/dictionary/convert`, { params: params } ) };

export const reqSendDTCANoticeAndEmail = params => { return instance.post(`${base}/email/sendDTCA`, params) };
export const reqSendIINoticeAndEmail = params => { return instance.post(`${base}/email/sendII`, params) };
export const reqSendCTCANoticeAndEmail = params => { return instance.post(`${base}/email/sendCTCA`, params) };
export const reqSendRICEmail = params => { return instance.post(`${base}/email/sendRIC`, params) };

export const reqGetTradeOpptByHours = params => { return instance.get(`${base}/realTimeData/getTradeOpptByHours`, { params: params }) };
export const reqGetTradeByDays = params => { return instance.get(`${base}/realTimeData/getTradeByDays`, { params: params }) };
export const reqGetTradeByMonthes = params => { return instance.get(`${base}/realTimeData/getTradeByMonthes`, { params: params }) };
export const reqGetOpptByDays = params => { return instance.get(`${base}/realTimeData/getOpptByDays`, { params: params }) };
export const reqGetOpptByMonthes = params => { return instance.get(`${base}/realTimeData/getOpptByMonthes`, { params: params }) };

export const reqAddSubscriptionEmail = params => { return instance.post(`${base}/subscriptionEmail/add`, params) };

export const uploadFileURL = `${base}/file/uploadFile`;
export const downloadFileURL = `${base}/file/downloadFile/`;

//  第三方微信登录test
export const reqGetWeChatLogin = params => { return instance.get(`${base}/webUser/callBack`, { params: params }) };
// 通过微信openid查询用户信息，若返回不为空，说明该用户已绑定微信，否则做为绑定处理.
// export const reqGetWeChatInfo = params => { return instance.post(`${base}/webUser/getWeChatInfoByOpenid`, qs.stringify(params)).then(res => res.data) }
export const reqGetWeChatInfo = params => { return instance.get(`${base}/webUser/weChatInfo`, { params: params }) };
// 根据用户输入的电话号码查询，1是否有这个用户，2是否绑定微信
export const reqGetBindingUser = params => { return instance.get(`${base}/webUser/bindingUser`, { params: params }) };
// 微信绑定用户账号，给用户账号添加微信唯一标识openId
export const reqEditBinding = params => { return instance.post(`${base}/webUser/bindingSucceed`, params) };

// 邀请全球合伙人成功发送邮件给被邀请人
export const reqSendInviterGlobalPartnerEmail = params => { return instance.post(`${base}/email/reqSendInviterGlobalPartnerEmail`, params) };

// 解绑微信，通过userId 设置openId为空。
export const reqResetOpenId = params => { return instance.post(`${base}/webUser/resetOpenId `, params) };

export const reqAliPay = params => { return instance.post(`${base}/web/alipay/pay`, qs.stringify(params)) };
export const reqPayPay = params => { return instance.post(`${base}/web/paypal/pay`, qs.stringify(params)) };

export const reqValidPhone = `${base}/validPhone`;
export const reqGetAttachmentsByProjId = params => {return instance.get(`${base}/attachment/getListByProjId`, {params: params})};
//汇总图最大、最小值设定
export const sMaxValue = `100`;
export const sMinValue = `5`;
//汇总图最大、最小圆半径设置
export const sMaxRadius = `20`;
export const sMinRadius = `5`;
//明细图最大、最小值设定
export const dMaxValue = `1000`;
export const dMinValue = `100`;
//明细图最大、最小圆半径设置
export const dMaxRadius = `40`;
export const dMinRadius = `5`;



// jdzx获取首页banner图片
export const reqBannerImage = params => {return instance.get(`${base}/web/index`, { params: params })};
// 项目详情广告图片
export const reqProjectDetailBannerImage = params => {return instance.get(`${base}/web/projectDetailBannerImage`, { params: params })};
// 首页焦点新闻中的焦点图片
export const reqFocusNewsImages = params => {return instance.get(`${base}/web/focusNewsImages`, { params: params })};
// 首页滚动的通知公告(发布最新的5条)：
export const reqNotificationAnnouncement = params => {return instance.get(`${base}/web/notificationAnnouncement`, { params: params })};
// 首页焦点类标题：
export const reqFocusTitle = params => {return instance.get(`${base}/web/focusTitle`, { params: params })};
// 首页政策法规,借贷知识：
export const reqPoliciesRegulations = params => {return instance.get(`${base}/web/policiesRegulations`, { params: params })};
// 通过id查询此条数据在表中的类型总数.
export const reqReferenceCenterPublishTypeCount = params => {return instance.get(`${base}/web/referenceCenterPublishTypeCount`, { params: params })};



// WEBPACK FOOTER //
// ./src/api/system-api.js